import { useParams } from 'react-router-dom';
import ApplyEvent from '@/features/apply-event/index.tsx';
import CommonError from '@/components/Error/CommonError.tsx';
import DatadogForceSession from '@/features/apply-event/components/DatadogForceSession/DatadogForceSession.tsx';

export default function EventRouter() {
  const { id } = useParams();

  const APPLY_EVENT = 'apply';

  if (id === APPLY_EVENT) {
    return (
      <DatadogForceSession>
        <ApplyEvent />
      </DatadogForceSession>
    );
  } else {
    return <CommonError />;
  }
}
